import React from 'react';

// Components
import {Key} from '../Key/Key';

// Style sheets
import Style from './Keypad.module.scss';

export function Keypad(props){
    const darkMode = props.darkMode;

    return(
        <div className={darkMode === true ? `${Style.Keypad} ${Style.DarkMode}` : Style.Keypad}>
            <div className={Style.Row}>
                <Key title="Clear" onClick={props.onClickHandleClear} color="Red" background={darkMode === true ? "DarkGrey" : "LightGrey"}wide="Wide" />
                <Key title="%" onClick={props.onClick} color="Green" background={darkMode === true ? "DarkGrey" : "LightGrey"}/>
                <Key title="/" onClick={props.onClick} color="Green" background={darkMode === true ? "DarkGrey" : "LightGrey"}/>
            </div>
            <div className={Style.Row}>
                <Key title="7" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="8" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="9" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="*" onClick={props.onClick} color="Green" background={darkMode === true ? "DarkGrey" : "LightGrey"}/>
            </div>
            <div className={Style.Row}>
                <Key title="4" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="5" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="6" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="-" onClick={props.onClick} color="Green" background={darkMode === true ? "DarkGrey" : "LightGrey"}/>
            </div>
            <div className={Style.Row}>
                <Key title="1" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="2" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="3" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="+" onClick={props.onClick} color="Green" background={darkMode === true ? "DarkGrey" : "LightGrey"}/>
            </div>
            <div className={Style.Row}>
                <Key title={<i className="fas fa-backspace"></i>} onClick={props.onClickHandleBackspace} color="Red" background="Transparant" />
                <Key title="0" onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="." onClick={props.onClick} color={darkMode === true ? "White" : "Black"} background="Transparant" />
                <Key title="=" onClick={props.onClickHandleCalculation} color="White" background="Green" />
            </div>
        </div>
    );
}